import store from '../../../store';
export default function checkIfCanSeeCertificates() {
  let scopes = store.getters.userScopes;
  return scopes.includes('certificates_list');
}
